import { FeatureRequestState } from '@/types'
import { BadgeProps, Badge as BaseBadge } from '../base/badge'

interface Props {
  state: FeatureRequestState
}

export const Badge = ({ state }: Props) => {
  const states: { [key in FeatureRequestState]: { color: BadgeProps['color'], text: string } } = {
    pending: {
      color: 'red',
      text: 'pending',
    },
    planned: {
      color: 'blue',
      text: 'planned',
    },
    started: {
      color: 'yellow',
      text: 'working on it',
    },
    beta: {
      color: 'lime',
      text: 'in beta',
    },
    released: {
      color: 'green',
      text: 'good to go',
    },
  }
  const { color, text } = states[state]
  return <BaseBadge color={color}>{ text }</BaseBadge>
}
